import NetStoriesRepository from '../../../data/repositories/writer/NetStoriesRepository';
import NetAnalyticsParticularEventsRepository from '../../../data/repositories/writer/NetAnalyticsParticularEventsRepository';

import {sendDefaultCustomEvent} from '../../../presentation/helpers/analytics';

export default class StoryFormCreateEvent {
  public async create() {
    try {
      const result = await new NetStoriesRepository().findBy({perPage: 1});
      const analyticsParticularEvent =
        await new NetAnalyticsParticularEventsRepository().create({
          analyticsParticularEventParams: {
            resourceType: 'story_form',
            actionName: 'create',
            resourceId: result.total + 1,
          },
        });
      sendDefaultCustomEvent({
        resourceType: 'story_form',
        resourceId: analyticsParticularEvent.userId,
        actionName: 'create',
      });
      switch (analyticsParticularEvent.sameEventsCount) {
        case 1:
          sendDefaultCustomEvent({
            resourceType: 'first_story_form',
            resourceId: analyticsParticularEvent.userId,
            actionName: 'create',
          });
          break;
        case 2:
          sendDefaultCustomEvent({
            resourceType: 'second_story_form',
            resourceId: analyticsParticularEvent.userId,
            actionName: 'create',
          });
          break;
      }
      return analyticsParticularEvent.sameEventsCount;
    } catch (e) {
      return null;
    }
  }
}
